import { createI18n } from 'vue-i18n';
import zhCN from './locales/zh-CN';
import en from './locales/en';
import { DEFAULT_LOCALE, persistLocale, resolveStoredLocale, type AppLocale } from '@/constants/locale';

const initialLocale = resolveStoredLocale();
persistLocale(initialLocale);

const i18n = createI18n({
  legacy: false,
  locale: initialLocale,
  fallbackLocale: DEFAULT_LOCALE,
  messages: {
    'zh-CN': zhCN,
    en,
  },
});

export function setAppLocale(locale: AppLocale) {
  i18n.global.locale.value = locale;
  persistLocale(locale);
}

export function getAppLocale(): AppLocale {
  return i18n.global.locale.value as AppLocale;
}

export default i18n;
